import { Type } from '@angular/core';
import { isDesktopViewport } from 'src/app/utils/responsive-nav-animation';

export const ROLL_MODAL_CLASS = 're-roll-modal';

export function createRollModalOptions<T>(
  component: Type<T>,
  componentProps?: Record<string, unknown>,
) {
  const base = {
    component,
    componentProps,
    cssClass: ROLL_MODAL_CLASS,
    showBackdrop: true,
  };

  if (isDesktopViewport()) {
    return base;
  }

  return {
    ...base,
    initialBreakpoint: 0.75,
    breakpoints: [0.25, 0.75, 1],
  };
}
